import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/_base/_auth/conversations/")({
  component: NavigateToList,
})

function NavigateToList() {
  return <Navigate to="/conversations/list" replace />
}
